import { EventEmitter2 } from "eventemitter2";
import $ from "jquery";
import { mergeMap } from "rxjs/operators";
import _ from "underscore";

import { actionCreators } from "../../actions";
import { RoomType } from "../../reducers/rooms";
import { PersistObject } from "../../service/Utils";
import { Epic } from "../../utils/types";
import { App } from "../App";

export type NewNameState = "initial" | "default" | "editing";

export class RoomsStore extends EventEmitter2 {
    private _roomsInput = new PersistObject("chalet_message_draft", {} as {[roomId: string]: string});
    private _newNames = {} as {[roomId: string]: string};
    private _nameTakenErrors = {} as {[roomId: string]: string | null};
    private _otherErrors = {} as {[roomId: string]: string | null};
    private _newNameIsDefaultValue = {} as {[roomId: string]: NewNameState};
    private _settingAccess = {} as {[roomId: string]: boolean};

    public roomInput (roomId: string) { return this._roomsInput.value[roomId] || ""; }
    public newName (roomId: string) { return this._newNames[roomId] || ""; }
    public newNameToSubmit (roomId: string) { return $.trim(this.newName(roomId)); }
    public nameTakenError (roomId: string) { return this._nameTakenErrors[roomId] || null; }
    public otherErrors (roomId: string) { return this._otherErrors[roomId] || null; }
    public newNameIsDefaultValue (roomId: string) { return this._newNameIsDefaultValue[roomId] || "initial"; }
    public settingAccess (roomId: string) { return this._settingAccess[roomId] || false; }

    constructor (private app: App) {
        super({ maxListeners: 20 });
    }

    public epic: Epic = (action$) => action$.pipe(
        mergeMap((action) => {
            if (action.type === actionCreators.RoomInput.type) {
                const {roomId, roomInput} = action.payload;
                const rooms = this._roomsInput.value;
                rooms[roomId] = roomInput;
                this._roomsInput.value = rooms;
                this.emit("changed");
            }
            else if (action.type === actionCreators.ForumNameValue.type) {
                const { roomId, value } = action.payload;
                this._newNames[roomId] = value;
                this._nameTakenErrors[roomId] = null;
                this._otherErrors[roomId] = null;
                this._newNameIsDefaultValue[roomId] = "editing";
                this.emit("changed");
            }
            else if (action.type === actionCreators.NewNameOnFocus.type) {
                const { roomId } = action.payload;
                this._nameTakenErrors[roomId] = null;
                this._otherErrors[roomId] = null;
                this._newNameIsDefaultValue[roomId] = "default";
                this.emit("changed");
            }
            else if (action.type === actionCreators.NewNameOnBlur.type) {
                const { roomId } = action.payload;
                this._newNameIsDefaultValue[roomId] = "initial";
                _.delay(() => {
                    this.emit("changed");
                }, 500);
            }
            else if (action.type === actionCreators.ToggleSettingAccess.type) {
                const { roomId } = action.payload;
                this._settingAccess[roomId] = !this._settingAccess[roomId];
                this.emit("changed");
            }
            else if (action.type === actionCreators.CreateForumSuccess.type) {
                const data = action.payload;

                _.each(data.rooms || [], (room) => {
                    _.defer(() => { // XXX
                        this.app.actionCreators.setRoomToOpen({ roomId: room.id, type: RoomType.REAL_TIME });
                    });
                });

                this.emit("changed");
            }
            else if (action.type === actionCreators.RenameForumError.type) {
                const { payload, operation } = action.payload;
                if (payload.code === "forum_name_is_in_use") {
                    const { room_id, name } = operation;
                    this._newNames[room_id] = "";
                    this._nameTakenErrors[room_id] = name;
                } else {
                    const { room_id } = operation;
                    this._otherErrors[room_id] = "Something wrong";
                    console.error("Failed to change forum", action);
                }
                this.emit("changed");
            }
            else if (action.type === actionCreators.RenameForum.type) {
                const { room_id } = action.payload;
                this._newNames[room_id] = "";
                this._newNameIsDefaultValue[room_id] = "initial";
                _.delay(() => {
                    this.emit("changed");
                }, 500);
            }
            return [];
        })
    )
}
